import { CommonModule, NgOptimizedImage, isPlatformBrowser } from '@angular/common';
import {
 AfterViewInit,
 Component,
 DestroyRef,
 ElementRef,
 Inject,
 Input,
 OnDestroy,
 PLATFORM_ID,
 QueryList,
 ViewChildren,
 inject,
} from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { FooterFeaturesComponent } from './features/features.component';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
 selector: 'iho-footer',
 standalone: true,
 imports: [
  CommonModule,
  RouterModule,
  MatExpansionModule,
  MatRippleModule,
  FooterFeaturesComponent,
  NgOptimizedImage,
 ],
 templateUrl: './footer.component.html',
 styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewInit, OnDestroy {
 @ViewChildren('expandControl') expandControls?: QueryList<ElementRef<HTMLLIElement>>;
 @Input() phoneNumber: string = '051-91005105';

 destroyRef = inject(DestroyRef);
 showLinks = false;
 subscription: Subscription;
 router = inject(Router);
 activeRoute = inject(ActivatedRoute);
 cdnUrl = cdnUrl;
 constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  this.subscription = this.router.events
   .pipe(
    takeUntilDestroyed(this.destroyRef),
    filter((event) => event instanceof NavigationEnd)
   )
   .subscribe((event: any) => {
    if (
      event.urlAfterRedirects == '/' ||
      event.urlAfterRedirects.includes('search') ||
      event.urlAfterRedirects.includes('hotel') 
     // event.urlAfterRedirects.includes('ecolodge')
    ) {
      if (!event.urlAfterRedirects.includes('ecolodge'))
     this.showLinks = true;
    else
        this.showLinks = false;
    } else {
     this.showLinks = false;
    }
   });
 }
 ngAfterViewInit(): void {
  this.expandControls?.get(0)?.nativeElement.classList.add('open');
 }
 ngOnDestroy(): void {
  this.subscription.unsubscribe();
 }

 goToCity(url: string, queryParams: any) {
  if (isPlatformBrowser(this.platformId)) {
   window.scrollTo({ top: 0, behavior: 'instant' });
   setTimeout(() => {
    this.router.navigate([url], { queryParams: queryParams });
   }, 100);
  }
 }
}
